import './styles.scss';

type Props = {
    image: string;
    className?: string;
};

export const ClientLogo: React.FC<Props> = ({image, className = 'client-logo'}: Props) => (
    <img src={image} className={className} alt='Logo' />
);
